import { useEffect } from 'react'

import { trackExperimentViewed } from '@mc/track-event'
import { useBucket, useExperimentVariables } from '@mc/experiments-react'

// https://app.growthbook.io/features/pen-4680_v1
const FLAG = 'pen-4680_v1'

export const useHPHeadingsExp = () => {
  useEffect(() => {
    trackExperimentViewed(FLAG)
  }, [])

  const bucket = useBucket(FLAG)
  const vars = useExperimentVariables(FLAG) as {
    heroTitle?: string
    heroSubtitle?: string
    firstQuizQuestion?: string
  }

  if (!bucket || bucket === 'control') {
    return {
      heroTitle: undefined,
      heroSubtitle: undefined,
      quizTitle: undefined,
      isHPHeadingsEnabled: false,
    }
  }

  return {
    heroTitle: vars?.heroTitle,
    heroSubtitle: vars?.heroSubtitle,
    firstQuizQuestionv2: vars?.firstQuizQuestion,
    isHPHeadingsEnabled: true,
  }
}
